import apiService from "../../api/api.service";
import { HeaderResponse } from "./header.types";

export const fetchHeader = () => {
  return apiService.get<HeaderResponse>("/general/header");
};